import React, { useEffect, useMemo } from 'react';
import { useWizard } from 'components/wizard/WizardContext';
import { useFetchVendorStudentMappings } from '../customHook';
import { getPaymentMappingPayload } from '../helper';
import StudentMappedDetails from './StudentMappedDetails';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import Footer from "modules/studentRefund/completionRefund/reinitiate/components/Footer";
import LinkedBankAccount from './LinkedBankAccount';
import { Card } from "reactstrap";
import { endpoint } from 'views/pages/manage/common/constant';
import { failureToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';

const StudentMappedDetailsPage = ({ isShowFooter = true, readOnly = false }) => {
    const { fetchStudentMappingList } = useFetchVendorStudentMappings();
    const { values, dropdowns, next } = useWizard();
    const vendorType = values?.vendorType;

    const vendorId = values?.vendorDetails?.id;
    const businessAreaId = values?.addVendorForm?.businessArea?.value;
    const yearId = values?.addVendorForm?.year?.value;

    const streamsDropdown = dropdowns?.data?.streams || [];

    useEffect(() => {
        if (!vendorId || !businessAreaId || !yearId) return;
        if (!streamsDropdown?.length) return;

        const allFetched = streamsDropdown.every(
            (stream) => values?.[stream?.label]?.hasData
        );

        if (allFetched) return;

        const fetchAllStreams = async () => {
            const url = vendorType?.toUpperCase() == 'INVIGILATOR' ? endpoint.raiseVendorRequest?.invigilator?.search : endpoint.raiseVendorRequest?.admissionAdvisor?.search
            try {
                await Promise.all(
                    streamsDropdown.map(async (stream) => {
                        const streamKey = stream?.label;
                        const streamData = values?.[streamKey];

                        if (streamData?.hasData || streamData?.loading) return;

                        const payload = getPaymentMappingPayload(values, stream);

                        await fetchStudentMappingList(
                            url,
                            payload,
                            0,
                            50,
                            streamKey
                        );
                    })
                );
            } catch (error) {
                console.error("Error fetching vendor student mappings:", error);
            }
        };

        fetchAllStreams();
    }, [
        vendorId,
        businessAreaId,
        yearId,
        streamsDropdown,
        fetchStudentMappingList
    ]);


    // Only show streams which have data
    const activeStreams = useMemo(() => {
        if (!streamsDropdown?.length) return [];

        return streamsDropdown.filter(
            (stream) => values?.[stream?.label]?.hasData
        );
    }, [streamsDropdown, values]);

    const isAnyStreamLoading = streamsDropdown.some(
        (stream) => values?.[stream?.label]?.loading
    );

    const isAllFetched = streamsDropdown.every(
        (stream) => values?.[stream?.label]?.hasData !== undefined
    );



    return (
        <>
            <div style={{ paddingBottom: isShowFooter ? "120px" : "20px" }}>

                {isAllFetched && activeStreams.length === 0 && (
                    <div style={{ padding: "40px", textAlign: "center" }}>
                        {vendorType?.toUpperCase() == 'INVIGILATOR' ? `Vendor ID ${vendorId} is not mapped to any Test ID in the system. Please contact
the EDP/Admin Team for mapping approval and try again` : "No students mapped yet"}
                    </div>
                )}

                <div style={{ margin: "15px" }}>
                    {activeStreams.map((stream) => (
                        <StudentMappedDetails
                            key={stream?.label}
                            stream={stream}
                            readOnly={readOnly}
                        />
                    ))}
                    <Card >
                        <LinkedBankAccount />
                    </Card>
                </div>
            </div>

            {isShowFooter && <Footer>
                <div>Payment details</div>
                <AButton
                    disabled={activeStreams?.length === 0}
                    onClick={() => { next(); }}
                    className="button_remove_left_margin"
                    variant="primary_filled"
                >
                    Proceed next
                </AButton>
            </Footer>
            }
        </>
    );
};

export default React.memo(StudentMappedDetailsPage);
